import { render, staticRenderFns } from "./RateStars.vue?vue&type=template&id=1cda844c&scoped=true"
import script from "./RateStars.vue?vue&type=script&lang=ts"
export * from "./RateStars.vue?vue&type=script&lang=ts"
import style0 from "./RateStars.vue?vue&type=style&index=0&id=1cda844c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cda844c",
  null
  
)

export default component.exports